import type { PLACEHOLDER_DATA, PLACEHOLDER_PARAMS } from './types'

import { DEFAULT_WIDTH } from '../const'

const DEFAULT_PLACEHOLDER_PARAMS_DEVICE = () => ({
  width: DEFAULT_WIDTH(),
  minHeight: { value: 100, unit: 'px' },
})

export const DEFAULT_PLACEHOLDER_PARAMS = (): PLACEHOLDER_PARAMS => ({
  pc: DEFAULT_PLACEHOLDER_PARAMS_DEVICE(),
  tablet: DEFAULT_PLACEHOLDER_PARAMS_DEVICE(),
  mobile: DEFAULT_PLACEHOLDER_PARAMS_DEVICE(),
})

export const DEFAULT_PLACEHOLDER_DATA = (): PLACEHOLDER_DATA => ({ type: 'placeholder' })